import apiSerial from '@/api/vo/serial';

const defaultState = () => ({
	listSerialCategory: [],
	listSerialMembership: [],
	serialMembershipPagination: '',
	detailSerialMembership: {},
	listSerialRegistration: [],
	serialRegistrationPagination: '',
	detailSerialRegistration: {},
	listAllAvaSerial: [],
	allAvaSerialPagination: '',
	listSerialAvaMember: [],
	serialAvaMemberPagination: '',
	listSerialAvaRegis: [],
	serialAvaRegisPagination: '',
	mySerialAvailable: null,
	responSukses: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSerialCategory(state, data) {
		let numb = 1
		let val = []
		data.data.map( (el) => {
			if (el.serial_type_name != "registrasi") {
				el['id'] = numb++
				val.push(el)
			}
		});
		state.listSerialCategory = val
	},
	setSerialMembership(state, data) {
		state.listSerialMembership = data.data;
		state.serialMembershipPagination = data.pagination;
	},
	setDetailSerialMembership(state, data) {
		state.detailSerialMembership = data
	},
	setSerialRegistration(state, data) {
		state.listSerialRegistration = data.data;
		state.serialRegistrationPagination = data.pagination;
	},
	setDetailSerialRegistration(state, data) {
		state.detailSerialRegistration = data
	},
	setAllAvaSerial(state, data) {
		state.listAllAvaSerial = data.data;
		state.allAvaSerialPagination = data.pagination;
	},
	setLoadAllAvaSerial(state, data) {
		state.listAllAvaSerial = [...state.listAllAvaSerial, ...data.data];
		state.allAvaSerialPagination = data.pagination;
	},
	setSerialAvaMember(state, data) {
		state.listSerialAvaMember = data.data;
		state.serialAvaMemberPagination = data.pagination;
	},
	setLoadSerialAvaMember(state, data) {
		state.listSerialAvaMember = [...state.listSerialAvaMember, ...data.data];
		state.serialAvaMemberPagination = data.pagination;
	},
	setSerialAvaRegis(state, data) {
		state.listSerialAvaRegis = data.data;
		state.serialAvaRegisPagination = data.pagination;
	},
	setLoadSerialAvaRegis(state, data) {
		state.listSerialAvaRegis = [...state.listSerialAvaRegis, ...data.data];
		state.serialAvaRegisPagination = data.pagination;
	},
	setMySerialAvailable(state, data) {
		state.mySerialAvailable = data.data;
	},
	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {
	getSerialCategory({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialCategory(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialCategory', data.results)
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialCategory', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getSerialMembership({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialMembership(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialMembership', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialMembership', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getDetailSerialMembership({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getDetailSerialMembership(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailSerialMembership', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailSerialMembership', {});
				reject()
			});
		});
	},

	getSerialRegistration({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialRegistration(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialRegistration', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialRegistration', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getDetailSerialRegistration({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getDetailSerialRegistration(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailSerialRegistration', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailSerialRegistration', {});
				reject()
			});
		});
	},

	getAllAvaSerial({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getAllAvaSerial(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setAllAvaSerial', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setAllAvaSerial', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getLoadAllAvaSerial({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getAllAvaSerial(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setLoadAllAvaSerial', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setLoadAllAvaSerial', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getSerialAvaMember({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvaMember(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialAvaMember', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialAvaMember', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getLoadSerialAvaMember({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvaMember(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setLoadSerialAvaMember', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setLoadSerialAvaMember', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getSerialAvaRegis({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvaRegis(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialAvaRegis', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialAvaRegis', { data: [], pagination: {} });
				reject()
			});
		});
	},
	
	getLoadSerialAvaRegis({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvaRegis(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setLoadSerialAvaRegis', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setLoadSerialAvaRegis', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getSerialAvailable({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvailable(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMySerialAvailable', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMySerialAvailable', null);
				reject()
			});
		});
	},

	getSerialAvailableMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvailableMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMySerialAvailable', data.results)
					resolve(data.results.data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMySerialAvailable', null);
				reject()
			});
		});
	},

	getSerialAvailablePramitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvailablePramitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMySerialAvailable', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMySerialAvailable', { data: [], pagination: {} });
				reject()
			});
		});
	},
	
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};